import React from 'react'
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useNavigate } from 'react-router-dom'

import { BaseMedia, StyledButton } from 'shared'
import { baseRoutes } from 'constants/routes'

interface ErrorPageProps {
  img: string
  title: string
  description: string
  alt: string
}

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 600,
    fontSize: 24,
    margin: '24px 0 12px',
  },
  description: {
    fontSize: 16,
    lineHeight: '20px',
    textAlign: 'center',
    color: theme.palette.grey[500],
    marginBottom: 32,
  },
}))

const ErrorPage = ({ img, title, description, alt }: ErrorPageProps) => {
  const classes = useStyles()
  const navigate = useNavigate()

  const onHomeClick = () => {
    navigate(baseRoutes.home)
  }

  return (
    <Grid
      container
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <BaseMedia src={img} alt={alt} />
      <Typography className={classes.title}>{title}</Typography>
      <Typography className={classes.description}>{description}</Typography>
      <StyledButton variant="contained" onClick={onHomeClick}>
        Back to Home
      </StyledButton>
    </Grid>
  )
}

export default ErrorPage
